// Global, server-synced setting controlling the age-display threshold used by
// person-marker tooltips (see media-lightbox.ts / persons.marker.ageModeBySetting).
// Cached in localStorage for synchronous access, with the canonical value synced
// to the server via the settings view (see views/settings.ts).
export const AGE_AUTO_THRESHOLD_KEY = 'radish-age-auto-threshold-years';

const DEFAULT_AGE_AUTO_THRESHOLD_YEARS = 3;

let _ageAutoThresholdYears: number = (() => {
  const stored = Number(localStorage.getItem(AGE_AUTO_THRESHOLD_KEY));
  return Number.isFinite(stored) && stored >= 0 ? stored : DEFAULT_AGE_AUTO_THRESHOLD_YEARS;
})();

export function getAgeAutoThresholdYears(): number {
  return _ageAutoThresholdYears;
}

export function setAgeAutoThresholdYears(years: number): void {
  const value = Number.isFinite(years) && years >= 0 ? years : DEFAULT_AGE_AUTO_THRESHOLD_YEARS;
  _ageAutoThresholdYears = value;
  localStorage.setItem(AGE_AUTO_THRESHOLD_KEY, String(value));
}
